import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faSearch,
  faAngleRight,
  faAngleLeft,
  faAngleUp,
  faAngleDown,
  faMinusSquare,
  faPlusSquare,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faChevronDown,
  faFileAlt,
  faTimes,
  faArrowUp,
  faArrowDown,
  faPlus,
  faMinus,
  faTrash,
  faDesktop,
  faColumns,
  faImage,
  faCode,
  faEye,
  faPaperPlane,
  faCheck,
  faShoppingCart,
  faDownload,
  faEyeSlash,
  faTags,
  faCaretDown,
  faCaretUp,
  faImages,
  faAlignLeft,
  faObjectGroup,
  faQuestion,
  faQuestionCircle,
  faExternalLinkAlt
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
 
export default {
  install(Vue, options = {}) {
    library.add(
      faSearch,
      faAngleRight,
      faAngleLeft,
      faAngleUp,
      faAngleDown,
      faMinusSquare,
      faPlusSquare,
      faChevronLeft,
      faChevronRight,
      faChevronUp,
      faChevronDown,
      faFileAlt,
      faTimes,
      faArrowUp,
      faArrowDown,
      faPlus,
      faMinus,
      faTrash,
      faDesktop,
      faColumns,
      faImage,
      faCode,
      faEye,
      faPaperPlane,
      faCheck,
      faShoppingCart,
      faDownload,
      faEyeSlash,
      faTags,
      faCaretDown,
      faCaretUp,
      faAlignLeft,
      faImages,
      faObjectGroup,
      faQuestion,
      faQuestionCircle,
      faExternalLinkAlt
    )

    Vue.component('font-awesome-icon', FontAwesomeIcon)
  }
}
